export default __webpack_public_path__ + "static/media/social-setup.e2866fca.png";